import { useLanguage, LANGS } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

// Segmented language control. Uses global context by default,
// or a controlled value/onChange (e.g. the Sample Report section).
export function LanguageToggle({ value, onChange, className, testIdPrefix = "lang", compact = false }) {
  const ctx = useLanguage();
  const active = value ?? ctx.lang;
  const set = onChange ?? ctx.setLang;

  return (
    <div
      className={cn(
        "inline-flex items-center gap-0.5 rounded-full border border-navy/15 bg-white/70",
        compact ? "p-0.5" : "p-1",
        className
      )}
      role="tablist"
      aria-label="Select language"
    >
      {LANGS.map((l) => {
        const isActive = active === l.id;
        return (
          <button
            key={l.id}
            role="tab"
            aria-selected={isActive}
            aria-label={l.label}
            data-testid={`${testIdPrefix}-${l.id}`}
            onClick={() => set(l.id)}
            className={cn(
              "rounded-full font-medium transition-all duration-300",
              compact ? "px-2 py-1 text-[11px]" : "px-3 py-1.5 text-xs",
              isActive
                ? "bg-navy text-cream shadow-sm"
                : "text-navy/60 hover:text-navy"
            )}
          >
            {compact ? l.short : l.label}
          </button>
        );
      })}
    </div>
  );
}
